import React, { FC, useState } from 'react'
import { IconNav, Overlay } from '@wmgtech/legato'

import { SideMenuProps } from './SideMenu.props'
import { AnimatedBell } from 'modulesCommon/Header/components'

import style from './SideMenu.module.scss'

export const SideMenu: FC<SideMenuProps> = ({
  children,
  quantity,
  isAnimatedBell,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Overlay
      open={isOpen}
      onOpenChange={setIsOpen}
      className={style.menu}
      placement="bottom-end"
      showFang={false}
      trigger={
        <IconNav isActive={isOpen} quantity={quantity} icon={<AnimatedBell isAnimated={isAnimatedBell} />} />
      }
    >{children}</Overlay>
  )
}
